import { mapGetters, mapActions } from 'vuex';
import dayjs from 'dayjs';
import Modal from '../components/Modal.vue';
import Daterangepicker from '../components/Daterangepicker.vue';
import Overview from '../components/Overview.vue';
import PriceDisplay from '../components/PriceDisplay.vue';
import MutationValue from '../components/MutationValue.vue';
import WalletHistoryMetas from '../components/WalletHistoryMetas.vue';
// import WDUpdateModal from '@/components/WDUpdateModal.vue';
import {
	duplicateVar,
	getDateRange,
	getAxiosErrorMessage,
	copyToClipboard,
	downloadFile,
} from '../lib/helper';
import walletApi from '../api/wallet';
import fileApi from '../api/file';
import { ORDIVO_ACCOUNT_NUMBER_BCA } from '../lib/statics';

const WdUpdateModal = () => import(/* webpackChunkName: "wd-update-modal" */ '@/components/WdUpdateModal.vue');

const defaultFilterDate = getDateRange();
const defaultSelectedStatus = { key: 'processing', label: 'Processing' };

export default {
	name: 'AdminWithdrawals',
	components: {
		Modal,
		Daterangepicker,
		Overview,
		PriceDisplay,
		MutationValue,
		WalletHistoryMetas,
		WdUpdateModal,
	},
	data() {
		return {
			keyword: '',
			limit: 25,
			page: 1,
			sort_by: 'created_at',
			sort: 'desc',
			status: 'processing',
			histories: [],
			history: null,
			isFetching: false,
			isAll: false,
			filterDate: defaultFilterDate,
			isConfirmVisible: false,
			isExporting: false,
			isCompleting: false,
			currency: 'Rp',
			file: null,
			fileUrl: '',
			statusOptions: [
				{ key: 'all', label: 'All' },
				{ key: 'pending', label: 'Pending' },
				{ key: 'processing', label: 'Processing' },
				{ key: 'cancelled', label: 'Cancelled' },
				{ key: 'completed', label: 'Completed' },
			],
			selectedStatus: defaultSelectedStatus,
			overviews: null,
			isUploading: false,
			isCancelVisible: false,
			isCancelling: false,
			isBulkUpdateVisible: false,
		};
	},
	methods: {
		...mapActions({
		}),
		resetHistories() {
			this.histories = [];
			this.isAll = false;
			this.page = 1;
		},
		fetchHistories(reset = true) {
			this.isFetching = true;
			if (reset) {
				this.resetHistories();
			}
			const params = this.getFetchParams();
			const callback = (response) => {
				const histories = response.data.data;
				histories.forEach((history) => {
					this.histories.push(history);
				});
				this.page++;
				if (histories.length < this.limit) {
					this.isAll = true;
				}
				this.isFetching = false;
			};
			const errorCallback = () => {
				this.isFetching = false;
				this.isAll = true;
			};
			walletApi.getAllHistories(params, callback, errorCallback);
		},
		init() {
			this.initFilterDate();
			this.fetchHistories();
			this.fetchOverviews();
		},
		setFilterDate(filterDate) {
			this.filterDate = filterDate;
			const since = dayjs(filterDate.start).format('YYYY-MM-DD');
			const until = dayjs(filterDate.end).format('YYYY-MM-DD');
			const query = duplicateVar(this.$route.query);
			query.since = since;
			query.until = until;
			const params = { query };
			this.$router.push(params);
			this.fetchHistories(true);
			this.fetchOverviews();
		},
		onKeywordChange() {
			const self = this;
			this.ooDelay(() => {
				self.fetchHistories();
			}, 1000);
		},
		handleScroll() {
			const pageHeight = document.documentElement.offsetHeight;
			const windowHeight = window.innerHeight;
			const scrollPosition = window.scrollY;
			const offset = 50;
			const isOnBottom = pageHeight - offset <= windowHeight + scrollPosition;
			if (isOnBottom) {
				if (!this.isFetching && !this.isAll) {
					this.fetchHistories(false);
				}
			}
		},
		changeSorting(key) {
			const isSame = this.sort_by === key;
			this.sort_by = key;
			const sort = isSame && this.sort === 'asc' ? 'desc' : 'asc';
			this.sort = sort;
			// Re-fetch
			this.fetchHistories(true);
		},
		sortClass(key) {
			const sameKey = this.sort_by === key;
			const className = sameKey ? `th-sort-${this.sort}` : '';
			return className;
		},
		checkCapabilities() {
			if (!this.isUserCan('wallet_view')) {
				this.$router.push('/');
			} else {
				this.isRouteChecked = true;
			}
		},
		formatDate(dateString) {
			const format = 'DD-MM-YYYY - HH:mm';
			const timezone = this.user.timezone;
			const formattedDate = this.moment.utc(dateString).tz(timezone).format(format);
			return dateString && dateString !== '' ? formattedDate : '';
		},
		initFilterDate() {
			if (this.since && this.since !== '' && this.until && this.until !== '') {
				const format = 'YYYY-MM-DD';
				const since = dayjs(this.since).format(format);
				const until = dayjs(this.until).format(format);
				const filterDate = {
					start: since,
					end: until,
				};
				this.filterDate = filterDate;
			}
		},
		getFetchParams() {
			const dateFormat = 'YYYY-MM-DD';
			const type = 'withdraw';
			const status = this.selectedStatus ? this.selectedStatus.key : 'processing';
			const startDate = dayjs(this.filterDate.start).format(dateFormat);
			const endDate = dayjs(this.filterDate.end).format(dateFormat);

			const params = {
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
				since: startDate,
				until: endDate,
				type,
			};

			if (status !== 'all') {
				params.status = status;
			}

			const keyword = this.keyword.trim();
			if (keyword && keyword !== '') {
				params.keyword = keyword;
			}

			return params;
		},
		showDetails() {
			// if (this.history && this.history.id === history.id) {
			// 	this.history = null;
			// 	return;
			// }
			// this.history = duplicateVar(history);
			// if (!history.details) {
			// 	const callback = (response) => {
			// 		const historyItem = response.data;
			// 		this.history = historyItem;
			// 		this.updateHistory(historyItem);
			// 	};
			// 	const errorCallback = () => {};
			// 	walletApi.getHistory(history.id, callback, errorCallback);
			// }
		},
		findObjectById(id) {
			return this.histories.find(obj => obj.id === id);
		},
		confirmComplete(history) {
			this.history = history;
			this.isConfirmVisible = true;
		},
		complete() {
			const id = this.history.id;
			const oldStatus = this.history.status;
			const params = {
				status: 'completed',
				old_status: oldStatus,
			};
			const callback = (response) => {
				const message = response.message;
				const history = response.data;
				this.updateHistory(history);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Complete',
					text: message,
				});
				this.isConfirmVisible = false;
				this.isCompleting = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Complete',
					text: message,
				});
				this.isCompleting = false;
			};
			walletApi.updateHistory(id, params, callback, errorCallback);

			this.savePaymentReceipt();
		},
		savePaymentReceipt() {
			const id = this.history.id;
			const params = {
				key: 'receipt',
				value: this.fileUrl,
			};
			const callback = () => {
				this.fileUrl = '';
			};
			const errorCallback = () => {
			};
			walletApi.addHistoryMeta(id, params, callback, errorCallback);
		},
		updateHistory(history) {
			const index = this.histories.findIndex(({ id }) => id === history.id);
			if (index !== -1) {
				const oldHistory = this.histories[index];
				const newHistory = Object.assign({}, oldHistory, history);
				this.$set(this.histories, index, newHistory);
			}
		},
		onSelectFile(event) {
			const files = event.target.files;
			if (files.length > 0) {
				const file = files[0];
				this.file = file;
				this.uploadFile(file);
			}
		},
		uploadFile(file) {
			this.isUploading = true;
			const username = this.user.username;
			const formData = new FormData();
			formData.append('file', file);
			formData.append('username', username);

			const callback = (response) => {
				const path = response.data;
				const url = `https://cdn.orderonline.id/${path}`;
				this.fileUrl = url;
				this.isUploading = false;
			};
			const errorCallback = () => {
				this.isUploading = false;
			};
			fileApi.upload(formData, callback, errorCallback);
		},
		fetchOverviews() {
			const dateFormat = 'YYYY-MM-DD';
			const startDate = dayjs(this.filterDate.start).format(dateFormat);
			const endDate = dayjs(this.filterDate.end).format(dateFormat);
			const params = {
				since: startDate,
				until: endDate,
			};
			const callback = (response) => {
				const overviews = response.data;
				this.overviews = overviews;
			};
			const errorCallback = () => {
			};
			walletApi.getWithdrawalStats(params, callback, errorCallback);
		},
		copy(text) {
			copyToClipboard(text);
			this.$notify({
				group: 'app',
				type: 'success',
				title: 'Success',
				text: 'copied to clipboard',
			});
		},
		getAccountNumber(history) {
			const metas = history.metas || [];
			const meta = metas.find(({ key }) => key === 'account_number');
			const accountNumber = meta ? meta.value : '';
			return accountNumber;
		},
		onSelectStatus(optionValue) {
			this.selectedStatus = optionValue;
			this.applyFilter();
		},
		applyFilter() {
			const selectedStatus = this.selectedStatus;
			const query = duplicateVar(this.$route.query);

			// status
			if (selectedStatus && selectedStatus !== null && selectedStatus !== '' && selectedStatus.key !== 'all') {
				query.status = selectedStatus.key;
				this.selectedStatus = selectedStatus;
			} else if (selectedStatus && selectedStatus.key === 'all') {
				delete query.status;
				this.selectedStatus = selectedStatus;
			} else {
				delete query.status;
				this.selectedStatus = defaultSelectedStatus;
			}

			const params = { path: document.location.pathname, query };
			this.$router.push(params);

			this.fetchHistories(true);
		},
		exportHistory(transferType = 'all', fileType = 'csv') {
			this.isExporting = true;
			const params = this.getFetchParams();
			params.account_number = ORDIVO_ACCOUNT_NUMBER_BCA;
			params.transfer_type = transferType;
			params.file_type = fileType;
			const callback = (response) => {
				const data = response.data;
				const url = data.url;
				const exportedIds = data.exported_ids || [];
				this.updateExported(exportedIds);
				downloadFile(url);
				this.isExporting = false;
			};
			const errorCallback = () => {
				this.isExporting = false;
			};
			walletApi.exportWithdrawals(params, callback, errorCallback);
		},
		updateExported(ids) {
			for (let index = 0; index < ids.length; index++) {
				const historyId = ids[index];
				const historyIndex = this.histories.findIndex(({ id }) => id === historyId);
				if (historyIndex !== -1) {
					const history = duplicateVar(this.histories[historyIndex]);
					history.is_exported = 1;
					this.$set(this.histories, historyIndex, history);
				}
			}
		},
		confirmCancel(history) {
			this.history = history;
			this.isCancelVisible = true;
		},
		cancel() {
			this.isCancelling = true;
			const id = this.history.id;
			const oldStatus = this.history.status;
			const params = {
				status: 'cancelled',
				old_status: oldStatus,
			};
			const callback = (response) => {
				const message = response.message;
				const history = response.data;
				this.updateHistory(history);
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Cancel WD',
					text: message,
				});
				this.isCancelVisible = false;
				this.isCancelling = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Cancel WD',
					text: message,
				});
				this.isCancelling = false;
			};
			walletApi.updateHistory(id, params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			isOwner: 'isOwner',
			isUserCan: 'isUserCan',
			bankAccounts: 'bankAccounts',
			presetRangeLabel: 'presetRangeLabel',
			filterDatePresets: 'filterDatePresets',
			members: 'members/all',
		}),
		since() {
			const since = this.$route.query.since;
			return since;
		},
		until() {
			const until = this.$route.query.until;
			return until;
		},
		queryStatus() {
			const status = this.$route.query.status;
			return status;
		},
		totalCompleted() {
			const value = this.overviews ? parseInt(this.overviews.completed) : 0;
			return this.formatNumberPlain(value);
		},
		totalProcessing() {
			const value = this.overviews ? parseInt(this.overviews.processing) : 0;
			return this.formatNumberPlain(value);
		},
	},
	watch: {
		user() {
			this.init();
		},
		// selectedStatus() {
		// 	this.fetchHistories(true);
		// },
	},
	created() {
		if (this.user) {
			this.init();
		}

		if (this.queryStatus && this.queryStatus !== '') {
			const selectedStatus = this.statusOptions.find(item => item.key === this.queryStatus);
			this.selectedStatus = selectedStatus;
		}

		window.addEventListener('scroll', this.handleScroll);
		document.addEventListener('scroll', this.onDocumentScroll, true);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
		document.removeEventListener('scroll', this.onDocumentScroll, true);
	},
};
